export var reportErrorLogImpl = function reportErrorLogImpl(aegisIns, errorLog) {
  var msg = errorLog.msg,
    _errorLog$consoleErro = errorLog.consoleError,
    consoleError = _errorLog$consoleErro === void 0 ? true : _errorLog$consoleErro,
    detail = errorLog.detail,
    level = errorLog.level,
    errorType = errorLog.errorType;
  if (consoleError) {
    console.error(msg);
  }
  aegisIns.report({
    level: 4,
    ext1: 'ERROR_LOG',
    msg: msg,
    ext3: JSON.stringify({
      level: level,
      errorType: errorType,
      detail: detail
    })
  });
};